'use client';

import { Box, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
export interface InvestStepItemProps {
  title: string;
  description: string;
  icon: ReactNode;
}
const InvestStepItem = ({
  title,
  description,
  icon
}: InvestStepItemProps): JSX.Element => {
  return <Stack justifyContent='center' sx={{
    height: '100%',
    cursor: 'pointer'
  }} data-sentry-element="Stack" data-sentry-component="InvestStepItem" data-sentry-source-file="InvestStepItem.tsx">
      <Stack direction='row' alignItems='center' justifyContent='space-between' gap='var(--spacing_xl)' sx={{
      width: {
        xs: '100%',
        sm: 480,
        md: 700
      },
      pl: 'var(--spacing_xxl)'
    }} data-sentry-element="Stack" data-sentry-source-file="InvestStepItem.tsx">
        <Stack sx={{
        maxWidth: {
          xs: 'auto',
          sm: 360,
          md: 476
        }
      }} gap='var(--spacing_s)' data-sentry-element="Stack" data-sentry-source-file="InvestStepItem.tsx">
          <Typography typography={{
          xs: 'bodyLargeStrong__Wallfund',
          md: 'headlineStrong__Wallfund'
        }} color={'primaryBrand.text'} data-sentry-element="Typography" data-sentry-source-file="InvestStepItem.tsx">
            {title}
          </Typography>
          <Typography textAlign='start' typography={{
          xs: 'bodyRegular__Wallfund',
          md: 'bodyLargeRegular__Wallfund'
        }} color='text.text' dangerouslySetInnerHTML={{
          __html: description
        }} data-sentry-element="Typography" data-sentry-source-file="InvestStepItem.tsx" />
        </Stack>

        <Box sx={{
        fontSize: {
          xs: 52,
          md: 100
        },
        lineHeight: 0
      }} data-sentry-element="Box" data-sentry-source-file="InvestStepItem.tsx">
          {icon}
        </Box>
      </Stack>
    </Stack>;
};
export default InvestStepItem;